@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

.certificationStatusesContainerTitle {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-design-gray80;
	margin-top: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
}

.certificationStatusesContainer {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	flex-wrap: wrap;
}